import React, { Component } from 'react';
import styled from 'styled-components';

import { Heading2 } from '../../';
import color from '../../colors';
import { media } from '../../../utils/Helper';

const Div = styled.div`
  background: ${color.lightGray};
  margin-right: calc(((100vw - 100%) / 2) * -1);
  margin-left: calc(((100vw - 100%) / 2) * -1);
  padding-bottom: 80px;
  padding-top: 80px;
  .max-width {
    max-width: 1200px;
    margin: 0 auto;
  }
`;
const Flex = styled.div`
  display: flex;
  padding-right: 7.5rem;
  padding-left: 7.5rem;
  flex-wrap: wrap;
  ${media.tablet`
  flex-direction: column; 
  padding-right: 1.6rem;
  padding-left: 1.6rem;
  `}
`;

interface OwnProps {
  h2: string;
}
interface OwnState {}

class MainServicesSection extends Component<OwnProps, OwnState> {
  render() {
    return (
      <Div>
        <Heading2>{this.props.h2}</Heading2>
        <div className="max-width">
          <Flex>{this.props.children}</Flex>
        </div>
      </Div>
    );
  }
}
export default MainServicesSection;
